import storeModule from '../../store-module'
import { defineStore } from 'pinia'

const url = 'dashboard/impacted-sales-channels'

export default defineStore(
  'dashboard-impacted-sales-channels',
  storeModule.createStoreModule('dashboard-impacted-sales-channels', {
    fetchFiltersURL: `${url}/filters`,
    fetchListURL: url
  })
)
